import React from 'react';
import { useAppSelector } from '@hooks/redux';
import { PipelineDesiredStatusCodes } from '@constants/pipelines';
import { pipelinesSelector } from '@redux/selectors/pipelineSelectors';
import PipelineSelect from '@components/pipelines/PipelineSelect/PipelineSelect';

const PromptExplorerPipelineSelect = ({
  selectedPipeline,
  loading,
  onPipelineSelect,
}: {
  selectedPipeline?: string;
  loading: boolean;
  onPipelineSelect: (value: string) => void;
}) => {
  const { data: pipelines } = useAppSelector((state) =>
    pipelinesSelector(state, PipelineDesiredStatusCodes.DEPLOYED),
  );

  return (
    <PipelineSelect
      selectedPipeline={selectedPipeline}
      pipelines={pipelines}
      loading={loading}
      onPipelineSelect={onPipelineSelect}
    />
  );
};

export default PromptExplorerPipelineSelect;
